import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema as schemaYup } from '@/pages/signUp/signUpAddress/yupAddressFields';
import React, { ReactElement } from 'react';
import {
  SignUpControllerInterface,
  UserSignAddressInterface,
} from '../SignUpInterface';

export const SignUpAddressController = ({
  user,
  setUser,
}: SignUpControllerInterface) => {
  const schema = schemaYup();
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
  } = useForm<UserSignAddressInterface>({
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const controlledTextView = (
    children: ReactElement,
    fieldName: 'zip' | 'address' | 'complement' | 'city' | 'state',
    actionOnChange?: (value: string) => void
  ) => {
    return (
      <Controller
        name={fieldName}
        control={control}
        defaultValue={user[fieldName]}
        render={({ field }) =>
          React.cloneElement(children, {
            onValueChange: (value: string) => {
              setUser({
                ...user,
                [fieldName]: value,
              });
              field.onChange(value);
              if (actionOnChange) actionOnChange(value);
            },
            error: !!errors[fieldName],
            helperText: errors[fieldName]?.message,
          })
        }
      />
    );
  };

  const triggerFieldUpdate = (
    fieldName: 'zip' | 'address' | 'complement' | 'city' | 'state',
    value: string
  ) => {
    setValue(fieldName, value, { shouldValidate: true, shouldDirty: true });
  };

  return { isValid, controlledTextView, handleSubmit, triggerFieldUpdate };
};
